import { defineFeatureRoutes } from '@/app/router/registry'
import { messages } from './i18n'

/** Exported so other packages (the channel card links here - task: "ссылку на него из карточки добавит другой пакет") do not hardcode the route name. */
export const CHANNEL_STATS_ROUTE = 'channel-stats'
export const SITE_STATS_ROUTE = 'site-stats'

export default defineFeatureRoutes([
  {
    path: '/channels/:id/stats',
    name: CHANNEL_STATS_ROUTE,
    component: () => import('./ChannelStatsView.vue'),
    props: true,
    meta: { title: messages.lazy('channelTitle') },
  },
  {
    path: '/stats',
    name: SITE_STATS_ROUTE,
    component: () => import('./SiteStatsView.vue'),
    // 'stats' (a bar chart) was added to NavIcon/NavIcon.vue by I4-seams -
    // docs/contract-requests/SC-console-stats.md п.1, which this package had
    // to work around with 'audit' (the journal's own glyph) because those two
    // files were outside its ownership.
    // Advanced view only (ux-simplify §3.1: not one of the operator's basic
    // entries; with "Обзор" added the basic menu would be 11 long). The
    // screen still opens by a direct link and from the channel card.
    meta: { title: messages.lazy('navTitle'), nav: { order: 54, icon: 'stats', group: 'system', advanced: true } },
  },
])
